import { getFormattedDate } from "@asmbl/shared/time";

export function DateCell({ value }: { value: string | Date }): JSX.Element {
  return <>{getFormattedDate(new Date(value))}</>;
}
